import React from "react";
import styled from "styled-components";
import { theme } from "@ui/styles/theme";
import { row } from "./layout";

interface TagProps extends React.HTMLAttributes<HTMLDivElement> {
	label: string;
	color?: string;
}

export const Tag: React.FC<TagProps> = ({ label, color, ...htmlProps }) => {
	return (
		<Container color={color} {...htmlProps}>
			{label}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>`
	background: ${({ color }) => (color ? color : theme.colors.primary)};
	${row(0, "center", "center")}
	padding: 2px 5px;
	border-radius: 13px;
	color: ${theme.colors.white};
	font-weight: 700;
	font-size: 10px;
	line-height: 16px;
`;
